

const getImage = (imgUrl:string) => new URL(`/src/assets/${imgUrl}`, import.meta.url).href

export default getImage